import React, { useRef, useState, useEffect } from 'react'
import headerBg from '../../assets/landing/shape_leaf_1.svg'
import { Link } from 'react-router-dom'
import logo from '../../assets/landing/logo.svg'
import { Button } from 'antd'
import { CgMenu, CgClose } from 'react-icons/cg'
import '../../App.css'

const navLinks = [
  { href: 'about', title: 'About' },
  { href: 'tokenomics', title: 'Tokenomics' },
  { href: 'roadmap', title: 'Roadmap' },
  { href: 'faq', title: 'Faq' }
]

const Header = () => {
  const [isOpenNav, setIsOpenNav] = useState(false)
  const menuRef = useRef(null)
  const hamburgerRef = useRef(null)

  // Handle click outside to close menu
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setIsOpenNav(false)
      }
    }

    if (isOpenNav) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpenNav])

  // Style w3m-button to match Connect Wallet button
  useEffect(() => {
    const styleW3MButton = () => {
      const w3mButton = document.querySelector('w3m-button')
      if (w3mButton) {
        // Apply direct styles to the w3m-button element
        w3mButton.style.cssText = `
          --w3m-accent: #006C28 !important;
          --w3m-color-mix: #006C28 !important;
          --w3m-color-mix-strength: 40 !important;
          --w3m-font-family: 'Sour Gummy', sans-serif !important;
          --w3m-border-radius-master: 9999px !important;
          --w3m-color-fg-1: #FEF200 !important;
          --w3m-color-bg-1: #006C28 !important;
          --w3m-color-overlay: #006C28 !important;
          border-radius: 9999px !important;
          
        `

        // Also try to style the shadow DOM content
        const observer = new MutationObserver(() => {
          const shadowRoot = w3mButton.shadowRoot
          if (shadowRoot) {
            const button =
              shadowRoot.querySelector('button') ||
              shadowRoot.querySelector('[role="button"]')
            if (button) {
              button.style.cssText = `
                background: #006C28 !important;
                color: #FEF200 !important;
                border: 2px solid #FEF200 !important;
                outline: 3px solid #006C28 !important;
                border-radius: 9999px !important;
                font-family: 'Sour Gummy', sans-serif !important;
                text-transform: uppercase !important;
                font-weight: 500 !important;
                padding: 8px 16px !important;
              `
            }
          }
        })

        observer.observe(w3mButton, { childList: true, subtree: true })

        return () => observer.disconnect()
      }
    }

    // Try to style immediately and also on interval
    const interval = setInterval(styleW3MButton, 100)
    styleW3MButton()

    return () => clearInterval(interval)
  }, [])

  const scrollToSection = id => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
    // Close menu after clicking on a menu item
    setIsOpenNav(false)
  }

  const handleConnectWallet = () => {
    const w3mButton = document.querySelector('w3m-button')
    if (w3mButton) {
      console.log('Attempting to click w3m-button:', w3mButton)
      const event = new MouseEvent('click', { bubbles: true, cancelable: true })
      w3mButton.dispatchEvent(event)
    } else {
      console.error('w3m-button not found')
    }
  }

  const toggleMenu = () => {
    setIsOpenNav(!isOpenNav)
  }

  return (
    <>
      <div
        className="flex items-center justify-between px-3 md:px-10 pt-16 bg-no-repeat font-sourGummy bg-[length:auto] lg:bg-[length:100%_70px] relative"
        style={{
          backgroundImage: `url(${headerBg})`
        }}
      >
        <div>
          <Link to="/">
            <img
              src={logo}
              alt="Logo"
              className="w-[210px] h-[41px] md:w-[266px] md:h-[56px]"
            />
          </Link>
        </div>
        <div className="hidden md:flex items-center justify-center gap-3">
          {navLinks.map((item, index) => (
            <div
              key={index}
              onClick={() => scrollToSection(item.href)}
              className="uppercase border-2 border-[#000000] px-4 py-1 rounded-full font-medium text-[#000000] text-lg font-sourGummy cursor-pointer hover:bg-[#FEF200] transition-colors duration-200"
            >
              {item.title}
            </div>
          ))}
        </div>
        <div className="hidden md:flex items-center justify-end gap-3 ">
          <select className="font-sourGummy bg-[#FEF200] border-2 border-[#000000] rounded-full outline outline-2 outline-[#FEF200] uppercase px-2 py-1">
            <option value="en">En</option>
            <option value="zh">中文</option>
          </select>
          <div className='bg-[#006c28] border-2 border-[#000000] rounded-xl outline outline-2 outline-[#FEF200] uppercase px-1.45'>
            <w3m-button />
          </div>
        </div>

        {/* Hamburger Menu Button */}
        <div
          ref={hamburgerRef}
          className="block md:hidden border-2 rounded-full border-[#000000] p-2 font-bold cursor-pointer hover:bg-[#FEF200] transition-colors duration-200 z-50"
          onClick={toggleMenu}
        >
          {isOpenNav ? <CgClose size={24} /> : <CgMenu size={24} />}
        </div>

        {/* Mobile Menu Dropdown */}
        {isOpenNav && (
          <>
            {/* Backdrop */}
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden" />

            {/* Menu Dialog */}
            <div
              ref={menuRef}
              className="absolute top-full right-3 mt-2 w-64 bg-white border-2 border-[#000000] rounded-2xl shadow-lg z-50 md:hidden overflow-hidden"
            >
              <div className="py-4">
                {navLinks.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => scrollToSection(item.href)}
                    className="px-6 py-3 text-lg font-sourGummy cursor-pointer hover:bg-[#FEF200] transition-colors duration-200 border-b border-gray-200 last:border-b-0 uppercase font-medium text-[#000000]"
                  >
                    {item.title}
                  </div>
                ))}

                {/* Language Select and Connect Wallet in Mobile Menu */}
                <div className="px-6 py-3 border-t border-gray-200 space-y-3">
                  <select className="w-full font-sourGummy bg-[#FEF200] border-2 border-[#000000] rounded-full outline outline-2 outline-[#FEF200] uppercase px-3 py-2">
                    <option value="en">En</option>
                    <option value="zh">中文</option>
                  </select>
                  <div className="w-full">
                    <w3m-button />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default Header
